<ng-container
  *ngIf="
    !(isLoading$ | async) && (locations$ | async) as locations;
    else loading
  "
>
  <div class="container">
    <div class="row">
      <div
        class="col-sm-6 col-md-4 col-lg-3 item"
        *ngFor="let location of locations?.stores"
      >
        <cx-store-finder-list-item
          [location]="location"
        ></cx-store-finder-list-item>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #loading>
  <div class="cx-spinner"><cx-spinner></cx-spinner></div>
</ng-template>
